var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItemValidityModalWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00781 16H16.0133C16.3397 15.9977 16.6606 15.9158 16.948 15.7613C17.2354 15.6069 17.4806 15.3847 17.6621 15.114C17.8436 14.8433 17.956 14.5325 17.9895 14.2085C18.0229 13.8845 17.9764 13.5573 17.854 13.2554L10.7512 1.02971C10.5782 0.717727 10.3245 0.457676 10.0167 0.276591C9.7088 0.0955069 9.35793 0 9.00053 0C8.64313 0 8.29225 0.0955069 7.98438 0.276591C7.67651 0.457676 7.42287 0.717727 7.24985 1.02971L0.147083 13.2554C0.0269779 13.5504 -0.0206489 13.8698 0.00817933 14.1869C0.0370075 14.504 0.141454 14.8096 0.312799 15.0782C0.484144 15.3469 0.717416 15.5707 0.993139 15.731C1.26886 15.8914 1.57904 15.9836 1.89776 16",
    fill: "#F9B609"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95752 5.2832L8.95752 9.4832M8.95752 12.621V12.6332",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemValidityModalWarning);
export default __webpack_public_path__ + "static/media/item-validity-modal-warning.b5c119dca40e923260fa6791ee5ed7a8.svg";
export { ForwardRef as ReactComponent };